import { observer } from "mobx-react-lite";
import { useEffect, useRef } from "react";
import { useAppStore } from "@/store";
import { OneClickImportContent } from "@/components/one-click-import/one-click-import-content";
import type { ImportStepProps } from "./import-types";

/**
 * OneClickImportStep is a wizard step that displays the one-click import interface.
 * It renders a wide MDSDialog container within the wizard's MDSModal.
 *
 * Navigation:
 * - Success: Navigates to "download-apps"
 * - Failure: Navigates to "apple-notes-1" (allows retry)
 * - Cancel: Navigates to "apple-notes-1"
 */
export const OneClickImportStep: React.FC<ImportStepProps> = observer(
  ({ onNavToStep, onClose }) => {
    const { store } = useAppStore();
    const hasStartedImport = useRef(false);

    // Start loading notes when the step mounts
    // Don't open the standalone modal since we're rendering content inside the wizard
    useEffect(() => {
      if (!hasStartedImport.current) {
        hasStartedImport.current = true;
        void store.oneClickImport.startImport("onboarding", { openModal: false });
      }
    }, [store.oneClickImport]);

    const handleImportSuccess = () => {
      onClose?.();
    };

    const handleCancel = () => {
      onNavToStep?.("apple-notes-1");
    };

    return (
      <OneClickImportContent
        onImportSuccess={handleImportSuccess}
        onCancel={handleCancel}
        entryPoint="onboarding"
        showCancelButton={true}
        isDismissable={false}
      />
    );
  }
);
